import { Provider } from '@angular/core';

import { SnackBarService } from './snack-bar.service';

export function provideSnackBar(): Provider[] {
  return [SnackBarService];
}
